import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  InputNumber,
  Input,
} from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import { useNavigate } from "react-router-dom";

const NewCounterParty = (props) => {
  const { currentCustomerObj, userData, refreshList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [statusData, setStatusData] = useState([]);
  const [kycStatusData, setKycStatusData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const params = {};
    const url = `${apiConfig.Counterparty}/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // console.log(res);

        let tempStatusData = [];
        let tempKycStatusData = [];

        objDetail?.statusOptions?.forEach((element) => {
          tempStatusData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.kycStatusOptions?.forEach((element) => {
          tempKycStatusData.push({
            value: element.id,
            label: element.value,
          });
        });

        setStatusData(tempStatusData);
        setKycStatusData(tempKycStatusData);
        setIsLoading(false);
      }
    });
  }

  const onSubmit = (formValues) => {
    formValues.customerId = currentCustomerObj.id;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Counterparty,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newCounterPartyMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={showModal}
        >
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>
      )}
      <Modal
        title="New Counter Party"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.bankName}
                name="bankName"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.bankName),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.bankName)}
                />
              </Form.Item>
            </Col>
            {/* Central Bank Code - Standard 8 or 11 character format */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.centralBankCode}
                name="centralBankCode"
                rules={[
                  // {
                  //   pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
                  //   message:
                  //     "Central Bank Code must be 8 or 11 characters (e.g., ABCDUS33 or ABCDUS33XXX)",
                  // },
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.centralBankCode),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.centralBankCode
                  )}
                  maxLength={11}
                  style={{ textTransform: "uppercase" }}
                  onChange={(e) => {
                    e.target.value = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            {/* Institution Code - Standard 8 or 11 character format */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.institutionCode}
                name="institutionCode"
                rules={[
                  // {
                  //   pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
                  //   message:
                  //     "Institution Code must be 8 or 11 characters (e.g., ABCDUS33 or ABCDUS33XXX)",
                  // },
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.institutionCode),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.institutionCode
                  )}
                  maxLength={11}
                  style={{ textTransform: "uppercase" }}
                  onChange={(e) => {
                    e.target.value = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            {/* Swift Code - Standard 8 or 11 character format */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.swiftCode}
                name="swiftCode"
                rules={[
                  {
                    pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
                    message:
                      "Swift Code must be 8 or 11 characters (e.g., ABCDUS33 or ABCDUS33XXX)",
                  },
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.swiftCode),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.swiftCode)}
                  maxLength={11}
                  style={{ textTransform: "uppercase" }}
                  onChange={(e) => {
                    e.target.value = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.creditRiskRating}
                name="creditRiskRating"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.creditRiskRating),
                  },
                ]}
              >
                <InputNumber
                  className="of-input"
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.creditRiskRating
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.maxLimitAmountLcy}
                name="maxLimitAmountLcy"
              >
                <InputNumber
                  className="of-input"
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.maxLimitAmountLcy
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.currentLimitUtilizationLcy}
                name="currentLimitUtilizationLcy"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(
                      labelConfig.currentLimitUtilizationLcy
                    ),
                  },
                ]}
              >
                <InputNumber
                  className="of-input"
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currentLimitUtilizationLcy
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.placementDealAccountLcy}
                name="externalDealAccountNumber"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(
                      labelConfig.placementDealAccountLcy
                    ),
                  },
                ]}
              >
                <Input
                  className="of-input"
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.placementDealAccountLcy
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactEmail}
                name="contactEmail"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.contactEmail),
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                  {
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email format",
                  },
                  {
                    max: 254,
                    message: "Email address cannot exceed 254 characters",
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactEmail
                  )}
                  maxLength={254}
                  type="email"
                />
              </Form.Item>
            </Col>
            {/* Contact Phone No - International format */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactPhoneNo}
                name="contactPhoneNo"
                rules={[
                  {
                    pattern: /^\+?[1-9]\d{1,14}$/,
                    message:
                      "Please enter a valid phone number (e.g., +1234567890)",
                  },
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.contactPhoneNo),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactPhoneNo
                  )}
                  maxLength={16}
                  onChange={(e) => {
                    // Allow only numbers, plus sign at the beginning, and spaces/hyphens for formatting
                    e.target.value = e.target.value.replace(/[^+\d\s-]/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.status}
                name="status"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.status),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.status} *`,
                    "select"
                  )}
                  options={statusData}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.kycStatus}
                name="kycStatus"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.kycStatus),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.kycStatus} *`,
                    "select"
                  )}
                  // options={staticConfig.kycStatusOptions}
                  options={kycStatusData}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default NewCounterParty;
